// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__wDTeP","productName":"Table_productName__2XOHb"};